const getUnidades = (state) => {
  return state.units
}

const getPerfis = (state) => {
  return state.profiles
}

const getUsuarios = (state) => {
  return state.users
}

const getPermissaoUni = (state) => {
  return state.permissaoUni
}

const getPermissaoServ = (state) => {
  return state.permissaoServ
}

export default {
  getUnidades,
  getPerfis,
  getUsuarios,
  getPermissaoUni,
  getPermissaoServ
}
